import { defineMessages } from 'react-intl'

export default defineMessages({
  communicationPreferencesHeading: {
    id: 'accountSettings.communicationPreferencesSection.heading',
    defaultMessage: 'Communication Preferences',
  },
  communicationPreferencesLabel: {
    id: 'accountSettings.communicationPreferencesSection.label',
    defaultMessage: 'Email & postal mail',
  },
})
